'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import type { ReferencesProductFilters_FiltersFragment } from '@gql-generated/graphql'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import {
  referencesProductArticlesFilteredReferencesAtom,
  referencesProductFiltersAtom,
  referencesProductFiltersEnrichedAtom,
} from '../services/referencesProduct.store'
import type { EnrichedFilter } from '../types/referencesProduct'

export function useEnrichedFilters(filters: ReferencesProductFilters_FiltersFragment[]) {
  const { t } = useTranslation(['referencesProductFilters'])
  const setEnrichedFilters = useSetAtom(referencesProductFiltersEnrichedAtom)
  // Will set how many references are available after applying filters
  const setFilters = useSetAtom(referencesProductFiltersAtom)
  const setFilteredReferences = useSetAtom(referencesProductArticlesFilteredReferencesAtom)
  useEffect(() => {
    const enrichedFiltersTemp: EnrichedFilter[] = filters.map((filter) => ({
      ...filter,
      labelWithUnit: filter.unit
        ? t('referencesProductFilters:labelWithUnit', { label: filter.label, unit: filter.unit })
        : filter.label,
      valuesChecked: [],
      values:
        filter.values?.map((value) => ({
          ...value,
          checked: false,
          disabled: false,
        })) || [],
    }))

    setEnrichedFilters(enrichedFiltersTemp)
    setFilters(filters)
    setFilteredReferences([])
  }, [setEnrichedFilters, setFilters, setFilteredReferences, t, filters])
}
